import { render, staticRenderFns } from "./PaoYingChup.vue?vue&type=template&id=b72a29de&scoped=true&"
import script from "./PaoYingChup.vue?vue&type=script&lang=js&"
export * from "./PaoYingChup.vue?vue&type=script&lang=js&"
import style0 from "./PaoYingChup.vue?vue&type=style&index=0&id=b72a29de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72a29de",
  null
  
)

export default component.exports